module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/ic-fb-43d72baccfb51e14a8993913202d7948.png";